import { createAppRules } from '../ability';
import { Action, Subject } from '../data';

export const PRODUCTION_MANAGER_RULES = createAppRules(can => {
	can(Action.all, Subject.PRODUCTION_PANEL);
});
